<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow"> 
      <!------------------------search---------------------->
      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
	      <el-form-item style="width:15%">
	          <el-select v-model="query.brandid" filterable clearable placeholder="按品牌" @change="isselect=true">	          
			  	  <el-option label="不分品牌" value="0"></el-option>
              	  <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
              	  	  <span style="float: left">{{item.name}}</span>
      				  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
              	  </el-option>
			  </el-select>
	      </el-form-item>
	      <el-form-item ref="productquery" :model="productquery">
	          <el-input placeholder="sku / 商品名称" v-model="query.key" clearable @keyup.enter.native="getList" @change="isselect=true"></el-input>
	      </el-form-item>
	      <el-form-item>
	          <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
	      </el-form-item>
		  <el-form-item>
			  <el-button type="warning" icon="el-icon-search" @click="checkjdinventorys">库存查询</el-button>
	      </el-form-item>
		  <el-form-item>
		  	  <input id="fileupload" type="file" @change="importfile(this)"  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" style="display:none" title="1"/>
		  	  <el-tooltip class="item" effect="dark" content="上传文件请从京东（交易云）选择商品进行下载" placement="top">
			  <el-button type="warning" icon="el-icon-upload2" @click="upload_goods_from_JD">上传京东商品信息</el-button>
			  </el-tooltip>
	      </el-form-item>

		  <!--
		  <el-form-item v-if="jdmoneys.money > 0 && jdmoneys.money!=''">
		  	  <template slot-scope="scope">
				  <span style="color:#909399" v-if="jdmoneys.status==0">当前京东预存款：<em style="color:#E6A23C;font-style:normal;font-weight:bold">￥{{jdmoneys.money}}</em></span>
				  <span style="color:#909399" v-if="jdmoneys.status==1">当前京东预存款：<em style="color:rgb(248, 93, 15);font-style:normal;font-weight:bold">￥{{jdmoneys.money}}（预存款不足，请及时充值）</em></span>		
			  </template>
		  </el-form-item>
		  -->
      </el-form>
      <!------------------------search end---------------------->
	  
      
      <div class="backborder2" style="margin-top:10px">
	      <el-table :data="lists" v-loading="ListLoading">
		      <el-table-column label="商品">
		      	  <template slot-scope="scope">
		      	  	  <div style="float:left;width:100%;">
		      	  	  	  <div style="float:left;width:65px;height:65px;border:1px solid #dddddd;border-radius:5px;background:rgba(221,221,221,.5);display:flex;align-items: center;justify-content: center;">
							  <img :id="'imginfo'+scope.row.id" :src="scope.row.imagePath=='' ? require('../../assets/default_img_mini.png') : scope.row.imagePath" class="cz-mall-goods" style="max-width:80%;height:80%"/>
						  </div>
		      	  	  	  <span style="float:left;margin-left:2%;width:72%;font-size:13px">{{scope.row.name}}</span>
						  <span style="float:left;margin-left:2%;width:72%;font-size:13px;color:rgb(144, 147, 153);line-height:25px">品牌：{{scope.row.brandName}}</span>
		      	  	  </div>
		      	  </template>
		      </el-table-column>
			  <el-table-column prop="sku" label="sku" width="130"></el-table-column>
		      <el-table-column prop="jdprice" label="京东售价" width="130" align="center"></el-table-column>
		      <el-table-column prop="price" label="协议售价" width="130" align="center"></el-table-column>
			  <el-table-column label="京东状态" width="130" align="center">
			  	  <template slot-scope="scope">
					  <el-tag type="info" v-if="scope.row.state==0">下架</el-tag>
					  <el-tag type="success" v-if="scope.row.state==1">上架</el-tag>
				  </template>
			  </el-table-column>
			  <el-table-column prop="desc" label="备注" width="130" align="center"></el-table-column>
		      <el-table-column label="操作" width="100" align="center">
			      <template slot-scope="scope">
				  	  <el-button type="warning" size="small" icon="el-icon-edit" circle  @click="editbrandCurrent(scope.row)"></el-button>
			          <el-button type="primary" size="small" icon="el-icon-tickets" circle  @click="showCurrent(scope.row)"></el-button>
			      </template>
		      </el-table-column>
	      </el-table>
	      <div class="block">
		      <!--分页begin-->
		      <el-pagination
		            @size-change="querySizeChange"
		            @current-change="queryCurrentChange"
		            :current-page="query.p"
		            :page-sizes="[10, 20, 50]"
		            :page-size="query.rollpage"
		            layout="total, sizes, prev, pager, next, jumper"
		            :total="lists_rows">
		      </el-pagination>
		      <!--分页end-->
	      </div>
      </div>
      
      <el-dialog title="查看商品详情" :visible.sync="detailDialog" width="45%" top="5vh">
	  	  <div style="width:96%;padding:.3rem 2% .3rem 2%;border-radius:5px;border:1px solid rgb(221,221,221,.9);background:rgb(221,221,221,.5)">
			  <span style="color:#F56C6C;font-size:.7rem">温馨提示：该同步信息为将本地京东商品信息与京东商品信息同步，并关联同步到线上商城，请慎用</span>
			  <el-button size="mini" type="danger" icon="el-icon-setting" :loading="updloading" @click="updatedetail(jddetails)" style="float:right;margin-right:0;margin-bottom:30px">同步</el-button>
		  </div>

		  <div class="infomain">
      	  	  <div class="img"><img :src="jddetails.imagePath" /></div>
      	  	  <div class="name">{{jddetails.name}}</div>
      	  	  <div class="price">
      	  	  	  <span>京东零售价：<i>{{jddetails.jdprice}}</i></span>
      	  	  	  <span>协议销售价：<i>{{jddetails.price}}</i></span>
      	  	  </div>
			  <!--
      	  	  <table class="spec" v-html="jddetails.param"></table>
			  -->
      	  	  <div class="desc" v-html="jddetails.czintroduction"></div>
      	  </div>
      	  <div slot="footer" class="dialog-footer">
      	  	  <el-button size="small" @click="detailDialog = false" style="margin-top:20px">取 消</el-button>
      	  </div>
      </el-dialog>

	  <el-dialog title="设置品牌信息" :visible.sync="editbrandDialog" width="20%" top="15vh">
	  	  <el-form :inline="true" class="demo-form-inline" size="small">
				<el-form-item style="width:100%">
					<el-select v-model="editbrand.brandid" filterable clearable placeholder="按品牌">	          
						<el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
							<span style="float: left">{{item.name}}</span>
							<span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
						</el-option>
					</el-select>
				</el-form-item>
		  </el-form>
		  <div slot="footer" class="dialog-footer">
            <el-button size="medium" @click="editbrandDialog = false">取 消</el-button>
            <el-button size="medium" type="primary" :loading="savebrandloading" @click="savebrand">保 存</el-button>
          </div>  
	  </el-dialog>

	  <!-- 京东商品更新信息 -->
	  <el-dialog title="京东商品更新内容" :visible.sync="showjdupdate" width="80%" top="10vh">
		  <div class="updatenav">
		  	  <a href="javascript:;" @click="changeupdate(4)" :class="activeindex==4 ? 'bt on' : 'bt'" style="margin-left:1%">
				上下架更新
				<h v-if="numstate > 0">{{numstate}}</h>
			  </a>
		  	  <a href="javascript:;" @click="changeupdate(2)" :class="activeindex==2 ? 'bt on' : 'bt'">
				价格更新
				<h v-if="numsprice > 0">{{numsprice}}</h>
			  </a>
			  <a href="javascript:;" @click="changeupdate(16)" :class="activeindex==16 ? 'bt on' : 'bt'">
			  	规格、详情信息更新
				<h v-if="numsupdate > 0">{{numsupdate}}</h>
			  </a>
			  <a href="javascript:;" @click="changeupdate(6)" :class="activeindex==6 ? 'bt on' : 'bt'">
			  	新增、删除商品更新
				<h v-if="numsnews > 0">{{numsnews}}</h>
			  </a>

			  <!-- 上下架更新 -->
			  <div class="updatemain">
			  	  <div style="float:left;width:100%;margin:10px 0 10px 0">
					  <el-tag type="danger">温馨提示：在进行京东数据同步时，每次只能同步100条数据</el-tag>
			  	  	  <el-button type="warning" @click="datasyn" icon="el-icon-setting" style="float:right;margin-bottom:10px" size="mini" :loading="syndataloading">同步京东数据</el-button>
				  </div>
			  	  <el-table :data="newslists" v-loading="newloading">
					  <el-table-column label="商品信息">
					  	  <template slot-scope="scope">
							  <img :src="scope.row.img"  style="float:left;width:10%;border-radius:5px;border:1px solid #ddd"/>
						  	  <p style="float:left;margin-left:2%;width:78%;margin-top:0">{{scope.row.name}}</p>
						  </template>
					  </el-table-column>
					  <el-table-column label="sku" prop="sku" width="150"></el-table-column>
					  <el-table-column label="状态" width="150" align="center" v-if="activeindex==4">
					  	  <template slot-scope="scope">
							  <span v-if="scope.row.state==0">下架</span>
							  <span v-if="scope.row.state==1">上架</span>
						  </template>
					  </el-table-column>
					  <el-table-column label="京东销售价" width="120" align="center" v-if="activeindex==2">
					  	  <template slot-scope="scope">
							  <span v-if="scope.row.basejdprice==scope.row.jdprice">{{scope.row.basejdprice}}</span>
							  <span v-if="scope.row.basejdprice!=scope.row.jdprice" style="text-decoration:line-through;color:red">{{scope.row.basejdprice}}</span>
							  <span v-if="scope.row.basejdprice!=scope.row.jdprice">{{scope.row.jdprice}}</span>
						  </template>
					  </el-table-column>
					  <el-table-column label="协议销售价" width="120" align="center" v-if="activeindex==2">
					  	  <template slot-scope="scope">
							  <span v-if="scope.row.baseprice==scope.row.price">{{scope.row.baseprice}}</span>
							  <span v-if="scope.row.baseprice!=scope.row.price" style="text-decoration:line-through;color:red">{{scope.row.baseprice}}</span>
							  <span v-if="scope.row.baseprice!=scope.row.price">{{scope.row.price}}</span>
						  </template>
					  </el-table-column>
					  <el-table-column label="时间" prop="time" width="160" align="center"></el-table-column>
				  </el-table>
				  <div class="block">
					<!--分页begin-->
					<el-pagination
						@size-change="newPageSizeChange"
						@current-change="newPageCurrentChange"
						:current-page="newsquery.p"
						:page-sizes="[10, 20, 50]"
						:page-size="newsquery.rollpage"
						layout="total, sizes, prev, pager, next, jumper"
						:total="newrow">
					</el-pagination>
					<!--分页end-->
				  </div>
			  </div>
		  </div>

		  <div slot="footer" class="dialog-footer">
              <el-button size="medium" @click="showjdupdate = false" style="margin-top:10px">取 消</el-button>
          </div>  
	  </el-dialog>


	  <!-- 上传京东商品 -->
	  <el-dialog title="上传京东商品" :visible.sync="fileupdloadlists.dialog" width="40%" top="10vh">
	  	  <span class="product-jd-goods-nums">当前上传商品数量：<i>{{fileupdloadlists.lists.length}}</i></span>
		  <el-button size="small" type="warning"  @click="saveuploadgoods" style="display:inline-block;float:right;margin-bottom:20px;">保 存</el-button>
		  <el-table :data="fileupdloadlists.lists" v-loading="fileupdloadlists.loading">
			  <el-table-column prop="sort" label="序号" min-width="130"></el-table-column>
		      <el-table-column prop="skuId" label="skuId" min-width="130" align="center"></el-table-column>
		      <el-table-column label="操作" min-width="100" align="center">
			      <template slot-scope="scope">
				  	  <el-button type="danger" size="small" round  @click="del[($delete(fileupdloadlists.lists,scope.$index))]">删除</el-button>
			      </template>
		      </el-table-column>
	      </el-table>
		  <div slot="footer" class="dialog-footer">
		  	  <el-button size="small" type="warning"  @click="saveuploadgoods">保 存</el-button>
		  </div> 
	  </el-dialog>


	  <!-- 数据同步中、请等待 -->
	  <el-dialog title="数据同步中" :visible.sync="uploadshow.dialog" width="30%" top="10vh">
	  		<span class="product-jd-goods-notice">数据同步过程中请勿随意点击取消，否则将导致同步失败</span>
			<el-progress :text-inside="true" :stroke-width="22" :percentage="uploadshow.percent" status="warning"></el-progress>
	  </el-dialog>


	  <!-- 同步结果信息 -->
	  <el-dialog title="数据上传结果" :visible.sync="errormsg.dialog" width="50%" top="10vh">
		  <div v-for="(item,index) in errormsg.data" class="jd-error-msg-show">
		  	  <img :src="item.status==0 ? require('../../assets/right_select_full.png') : require('../../assets/error-full.png')" />
		  	  skuid：【{{item.skuid}}】{{item.status==0 ? '上传成功' : '上传失败，'}} {{item.status==0 ? '' : '失败原因：【'+item.msg+'】'}}
		  </div>
	  </el-dialog>


      
  </div>
  </transition>   
</template>

<script>

export default {
  data () {
    return {
      actionauth:'', //操作功能权限
      url:this.GLOBAL.domain+"Product/index",
      transitionshow:true,
      brandlists:[],
      brandquery: {
	  	  act:'lists',
		  token:this.$cookies.get('token'),
		  rollpage:100000
	  },
	  query: {
	  	  act:'jdlists',
	  	  token:this.$cookies.get('token'),
	  	  brandid:'',
	  	  key:'',
	  	  p:1,
	  	  rollpage:10,
	  },
      lists:[],
      ListLoading:false,
      lists_rows:0,
      isselect:false,
      jddetails:[],
      detailDialog:false,
	  savebrandloading:false,
	  editbrandDialog:false,
	  editbrand: {
		  act:'editbrand',
		  token:this.$cookies.get('token'),
		  id:'',
		  brandid:'',
	  },
	  jdmoneys:[],
	  showjdnews:false,
	  showjdupdate:false,
	  newslists:[],
	  newloading:false,
	  activeindex:4,
	  newrow:0,
	  newsquery: {
		  act:'getjdnewslists',
		  token:this.$cookies.get('token'),
		  type:'4',
		  p:1,
		  rollpage:10
	  },
	  numstate:0,
	  numsprice:0,
	  numsupdate:0,
	  numsnews:0,
	  tagshow:true,
	  syndataloading:false,
	  updloading:false,

	  fileupdloadlists:{
		  dialog:false,
		  loading:false,
		  lists:[]
	  },
	  
	  uploadobj:false,
	  uploadshow: {
		  dialog:false,
		  loading:false,
		  obj:false,
		  time:3000,        //轮询间隔时间
		  rollpage:3,	    //单次提交商品数量
		  pagenums:0,       //当前执行页数
		  allpagenums:0,    //可执行的总页数
		  percent:0,		//当前完成任务进度百分比
		  isflag:false,   //是否正在执行操作
		  isfinish:false, //是否上传结束
		  lists:[], //待保存的商品
	  },

	  errormsg: {
		  dialog:false,
		  data:[]
	  },
      
    }
  },
  mounted(){
  	  this.getactionauth();
      this.getBrand(); //获取京东商品品牌
      this.getList(); //获取京东商品信息
	  this.getjdlastmoney(); //获取京东进货备用金额
	  this.getjdnews(); //获取京东更新信息
  },
  methods:{

	/** 上传京东商品信息 **/
	upload_goods_from_JD() {
		document.getElementById("fileupload").click();
	},

	/** 导入京东商品信息 **/
	importfile(obj) {
		  let _this = this;
          let inputDOM = this.$refs.inputer;

          // 通过DOM取文件数据
          this.file = event.currentTarget.files[0];                
          var rABS = false; //是否将文件读取为二进制字符串
          var f = this.file;
          var outdata;
          var nums=0;
          var address='';
          var reader = new FileReader();
          this.fileupdloadlists.lists=[];

		  this.fileupdloadlists.dialog=true;
          this.fileupdloadlists.loading=true;
          FileReader.prototype.readAsBinaryString = function(f) {
            var binary = "";
            var rABS = false; //是否将文件读取为二进制字符串
            var pt = this;
            var wb; //读取完成的数据
            var reader = new FileReader();
            reader.onload = function(e) {
            	var bytes = new Uint8Array(reader.result);
                var length = bytes.byteLength;
                for(var i = 0; i < length; i++) binary += String.fromCharCode(bytes[i]);
                var XLSX = require('xlsx');
                if(rABS) {
                	wb = XLSX.read(btoa(fixdata(binary)), {type:'base64'});
                }else {
                    wb = XLSX.read(binary, {type: 'binary'});
                }
                outdata = XLSX.utils.sheet_to_json(wb.Sheets[wb.SheetNames[0]]);//outdata就是你想要的东西
                outdata.forEach(function(item,index) {
                    nums++;
                    _this.fileupdloadlists.lists.push({
                        sort:nums,
                        skuId:item['skuId'] ? item['skuId'] : item['SKUID']
                    });
                });

                //清空输入框的文件值，避免下次change事件失效
                document.getElementById('fileupload').value = null;     
                _this.fileupdloadlists.loading=false;      
            }
            reader.readAsArrayBuffer(f);
          }

          if(rABS) {
        	  reader.readAsArrayBuffer(f);
          } else {
              reader.readAsBinaryString(f);
          }   
	},


	/** 保存上传的商品信息 **/
	saveuploadgoods() {
		if(this.fileupdloadlists.lists.length==0) {this.$message.error("上传商品不能为空");return false;}
		//重置错误信息提示
		this.errormsg.dialog=false;
		this.errormsg.data=[];
		
		//初始化数据
		//1、sku信息分包处理（获取总页数）、当前执行页数、执行百分比、正在执行操作、操作完成
		this.uploadshow.allpagenums=parseInt(this.fileupdloadlists.lists.length/this.uploadshow.rollpage);
		this.uploadshow.allpagenums+=parseInt(this.fileupdloadlists.lists.length%this.uploadshow.rollpage) > 0 ? parseInt(1) : parseInt(0);
		this.uploadshow.pagenums=0;
		this.uploadshow.percent=0;
		this.uploadshow.isflag=false;
		this.uploadshow.isfinish=false;
		this.uploadshow.dialog=true;

		//2、分包设置sku信息
		this.uploadshow.lists=[];
		var pagestart=0;
		var pageend=0;
		var paramlists=[];
		for(var i=0;i < this.uploadshow.allpagenums; i++) {
			pagestart=i*this.uploadshow.rollpage;
			pageend=(i+1)*this.uploadshow.rollpage - 1;
			paramlists=[];
			for(var ii=0;ii < this.fileupdloadlists.lists.length; ii++) {
				if(ii >= pagestart && ii <= pageend)  {
					paramlists.push(this.fileupdloadlists.lists[ii].skuId);
				}
			}
			paramlists=paramlists.join(',');
			this.uploadshow.lists.push(paramlists);
		}

		//3、生成定时器并执行上传操作
		this.uploadobj=setInterval(this.syn_jd_goods_from_cz,this.uploadshow.time);
	},

	//同步京东商品信息到宠赞
	syn_jd_goods_from_cz() {
		//限制三件套
		if(this.uploadshow.isflag) return false;
		if(this.uploadshow.isfinish) return false;
		this.uploadshow.isflag=true;

		//执行数据同步至后台
		var resource = this.$resource(this.GLOBAL.domain+"Jdproduct/index");		    
	    resource.save({act:'savegoodstocz',token:this.$cookies.get('token'),skuIds:this.uploadshow.lists[0]}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
				var result = JSON.parse(Base64.decode(res.data.Data)); //获取提示信息
				let _this=this;
				//获取提示信息并进行封装
				result.forEach(function(item,index) {
					_this.errormsg.data.push(item);
				});

				//清空同步的数据
				this.$delete(this.uploadshow.lists,0);
				//计算百分比进度
				this.getsynpercent();
			}
	    }).catch((res) => {
	          	
	    });
	},

	//计算数据同步进度
	getsynpercent() {

		//计算进度完成
		this.uploadshow.pagenums++;
		var percent=parseInt(this.uploadshow.pagenums/this.uploadshow.allpagenums*100);
		percent >= 100 ? this.uploadshow.percent=100 : this.uploadshow.percent=percent;

		if(percent >= 100) {
			this.uploadshow.isfinish=true;
			//关闭定时器
			//ClearInterval(this.uploadobj);
			//延迟关闭
			var _this=this;
			setTimeout(function() {
				_this.uploadshow.dialog=false;
				_this.fileupdloadlists.dialog=false;
				_this.getList(); //刷新列表
				_this.errormsg.dialog=true; //打开同步结果

			},500);

		}else {
			this.uploadshow.isflag=false;
		}
	},




  	
  	/** 获取操作功能权限 **/
  	getactionauth() {
    	var data =this.$cookies.get('actionauth');
    	data=JSON.parse(data);
        this.actionauth=data;
    },
    
    //获取品牌
	getBrand(){
	    var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
	    resource.query(this.brandquery).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
			    this.brandlists = JSON.parse(Base64.decode(res.data.Data));
			}
	    }).catch((res) => {
	          	
	    });
	},

	//获取京东更新信息
	getjdnews() {
		var resource = this.$resource(this.GLOBAL.domain+"Product/index");		    
	    resource.query({act:'getjdnews',token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
			    var result = JSON.parse(Base64.decode(res.data.Data));
				this.showjdnews=result.status;
			}
	    }).catch((res) => {
	          	
	    });
	},
	
	//获取京东商品信息
	getList(){
		if(this.isselect==true) {
			this.query.p=1;
			this.query.rollpage=10;
		}
	
		this.ListLoading=true;
	    var resource = this.$resource(this.url);		    
	    resource.query(this.query).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			    this.ListLoading=false;
			}else{
			    this.lists = JSON.parse(Base64.decode(res.data.Data));
			    this.lists_rows = parseInt(res.data.count);
			    this.ListLoading=false;
			    if(this.isselect==true) this.isselect=false;


			}
	    }).catch((res) => {
	        this.ListLoading=false;
	    });
	},
	
	querySizeChange(val) {
	    this.query.rollpage = val;
	    this.getList();
	},
	queryCurrentChange(val) {
	    this.query.p = val;
	    this.getList();
	},

	/** 编辑商品品牌信息 **/
    editbrandCurrent(item) {
	  	this.editbrandDialog=true;
	    this.editbrand.id=item.id;
		this.editbrand.brandid=item.agentbrandid==0 ? '' : item.agentbrandid;
	},

	/** 保存商品品牌信息 **/
	savebrand() {
		this.savebrandloading=true;
	    var resource = this.$resource(this.url);		    
	    resource.query(this.editbrand).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			    this.savebrandloading=false;
			}else{
			    this.savebrandloading=false;
			    this.$message.success('设置品牌信息成功');
				this.editbrandDialog=false;
				this.getList();
			}
	    }).catch((res) => {
	        this.savebrandloading=false;
	    });
	},
    
    /** 查询商品详情 **/
    showCurrent(item) {
    	this.detailDialog=true;
    	var resource = this.$resource(this.url);		    
	    resource.query({act:'jddetail',token:this.$cookies.get('token'),id:item.id}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
			    this.jddetails = JSON.parse(Base64.decode(res.data.Data));
			}
	    }).catch((res) => {
	        
	    });
    },


	/** 同步更新商品信息 **/
	updatedetail(item) {
		this.updloading=true;
		var resource = this.$resource(this.GLOBAL.domain+"Jdproduct/index");		    
	    resource.query({act:'updatejdgoods',token:this.$cookies.get('token'),sku:item.sku}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
				this.updloading=false;
			}else{
				this.$message.success('京东数据同步成功');
			    this.showCurrent(item);
				this.updloading=false;
			}
	    }).catch((res) => {
	        this.updloading=false;
	    });
	},


	/** 获取京东进货预存金额 **/
	getjdlastmoney() {
		var resource = this.$resource(this.url);		    
	    resource.query({act:'getjdlastmoney',token:this.$cookies.get('token')}).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
			}else{
			    this.jdmoneys = JSON.parse(Base64.decode(res.data.Data));
			}
	    }).catch((res) => {
	        
	    });
	},


	//获取新消息
	getnotice() {
		this.showjdupdate=true;
		this.checkjdnotice();
	},

	//切换信息类型
	changeupdate(index) {
		this.activeindex=index;
		this.newsquery.p=1;
		this.newsquery.rollpage=10;
		this.newsquery.type=this.activeindex;
		this.checkjdnotice();
	},

	/** 检查京东商品信息变更 **/
	checkjdnotice() {
		if(this.activeindex==6) this.newrow=0;
		this.newslists=[];
		this.newloading=true;
		var resource = this.$resource(this.url);		    
	    resource.query(this.newsquery).then((res) => {
			if(res.data.Result>0){
			    if(res.data.Result=='70001') this.$router.push('/login')
			    this.$message.error(res.data.Message);
				this.newloading=false;
			}else{
			    var result = JSON.parse(Base64.decode(res.data.Data));
				this.newslists=result.lists;
				this.newrow=parseInt(res.data.count);
				this.numslists=result.nums;
				this.numstate=this.numslists.state;
				this.numsprice=this.numslists.price;
				this.numsupdate=this.numslists.update;
				this.numsnews=this.numslists.news;
				this.newloading=false;
			}
	    }).catch((res) => {
	        this.newloading=false;
	    });
	},

	newPageSizeChange(val) {
        this.newsquery.rollpage = val;
        this.checkjdnotice();
    },
    newPageCurrentChange(val) {
        this.newsquery.p = val;
        this.checkjdnotice();
    },

	//京东数据同步
	datasyn() {
		//if(this.activeindex==6) {this.$message.warning('新增、删除商品更新信息请联系技术人员');return false;}
		this.syndataloading=true;

		var resource = this.$resource(this.url);		    
		resource.query({act:'syndata',token:this.$cookies.get('token'),type:this.activeindex}).then((res) => {
			if(res.data.Result>0){
				if(res.data.Result=='70001') this.$router.push('/login')
				this.$message.error(res.data.Message);
				this.syndataloading=false;
			}else{
				this.$message.success('信息同步成功');
				this.changeupdate(this.activeindex);
				this.syndataloading=false;
			}
		}).catch((res) => {
			this.syndataloading=false;
		});
	},

	closetag() {
		this.tagshow=false;
	},

	//检测京东商品库存
	checkjdinventorys() {
		this.$emit('listenchild',{name:'京东库存查询',url:'jdinventorycheck'}); //关闭窗口
	},

	//批量更新京东商品信息
	updatemoregoods() {
		
	},

  }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.infomain {float:left;width:100%}
.infomain .img {float:left;width:100%;background:rgba(221,221,221,.4)}
.infomain .img img {float:left;width:70%;margin-left:15%}
.infomain .name {float:left;width:100%;margin-top:30px;font-size:13px;line-height:24px;font-weight:540}
.infomain .price {float:left;width:100%;margin-top:10px;font-size:13px}
.price span {float:left;margin-right:5%}
.price span i {font-style:normal;font-weight:550;color:rgb(233, 63, 69);font-size:14px}
.infomain .spec {float:left;width:100%;margin-top:40px;font-size:1em;}
.infomain .spec .tdTitle {font-size:13px;padding:10px 0}
.infomain .desc {float:left;width:100%;margin-top:10px;overflow:hidden}
.infomain .desc img {float:left;width:100%}
.jdnotice {transition:all .3s;padding:.3rem 1% .3rem 1%;border-radius:5px;background-color:rgb(192,196,204,.7);border:1px solid rgb(192,196,204,.4);color:#f56c6c;white-space:nowrap;margin:10px 0 10px 0;font-size:.7rem}
.jdnotice span {margin-right:.5%}
.jdnotice a {padding:.3rem .5rem;border-radius:5px;color:#fff;background:rgb(248, 93, 15);text-decoration:none}

.updatenav {background-color:rgb(240, 240, 240,.3);float:left;width:96%;padding:2%}
.updatenav .bt {border:1px solid #ddd;border-bottom:none;border-radius:5px 5px 0 0;text-decoration:none;background:#ddd;color:#fff;padding:.4rem .5rem;transition:all .3s;margin-right:2px}
.updatenav .bt h {padding:.2rem .4rem;background:red;color:#fff;border-radius:30px;font-size:.1rem;position:absolute;line-height:.8rem;margin-top:-.9rem}
.updatenav .on {background-color:rgb(255,255,255);color:#606266;padding:.4rem 1.5rem}
.updatenav .updatemain {float:left;width:96%;background:#fff;border-radius:5px;padding:2%}
.cz-mall-goods {float:left;border-radius:5px}

.product-jd-goods-nums {display:inline-block;color:#f56c6c;font-size:13px;}
.product-jd-goods-nums i {font-style:normal;font-size:14px;font-weight:bold;}
.product-jd-goods-notice {display:inline-block;width:100%;text-align:center;font-size:13px;padding:20px 0;}
.jd-error-msg-show {display:flex;justify-content:left;align-items:center;width:100%;line-height:23px;font-size:13px;padding:10px 0;}
.jd-error-msg-show img {width:25px;height:25px;margin-right:10px;}
</style>


// WEBPACK FOOTER //
// src/components/inventory/JDProduct.vue